// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BasicRole, BasicRoleSchema } from 'api/gen/BasicRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { OtherSubject, OtherSubjectSchema } from 'api/gen/OtherSubject';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { User, UserSchema } from 'api/gen/User';

const requiredPart = t.interface({
  approvedFrom: DateSchema,
  approvedTo: t.union([DateSchema, t.null]),
  otherSubject: OtherSubjectSchema,
  role: BasicRoleSchema,
  user: UserSchema,
  userProfileOtherSubjectRoleId: PositiveIntegerSchema,
});

export const UserProfileOtherSubjectRoleSchema = excess(requiredPart);

export interface UserProfileOtherSubjectRole extends t.TypeOf<typeof UserProfileOtherSubjectRoleSchema> {}
